// Get the modal
const modal = document.getElementById("myModal");

// Get the image and insert it inside the modal - use its "alt" text as a caption
let img = document.querySelectorAll('.gallery-item img'),
    gallery = document.querySelector('.gallery'),
    modalImg = document.getElementById('img01'),
    body = document.querySelector('body');

if(gallery) {
    gallery.addEventListener('click', (e) => {
        if(!e.target.src || !modal) return;
        modal.style.display = "block";
        modalImg.src = e.target.src;
        body.style.overflow = 'hidden';
    });
}

// Get the <span> element that closes the modal
let close = document.querySelector('#myModal .close');

// When the user clicks on <span> (x), close the modal
if(close) {
    close.onclick = function() {
        body.style.overflow = 'auto';
        modal.style.display = "none";
    }
}

